export default "__VITE_ASSET__41a21e7b__"